import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'upsc-custom-error',
  templateUrl: './custom-error.component.html',
  styleUrls: ['./custom-error.component.scss']
})
export class CustomErrorComponent {
constructor(
    public snackBarRef: MatSnackBarRef<CustomErrorComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  close() {
    this.snackBarRef.dismiss();
  }
}
